var _defs, _circle, _rect, _circle2, _text, _path, _rect2, _circle3, _text2, _rect3, _circle4, _text3, _path2, _rect4, _circle5, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAndusFinalCtaEngagementPathsDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 650,
    height: 500,
    viewBox: "0 0 650 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Two ways to engage with AndUs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "aboutCtaGlow"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087CFF",
    stopOpacity: 0
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 250,
    r: 238,
    fill: "url(#aboutCtaGlow)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 36,
    width: 310,
    height: 104,
    rx: 21,
    fill: "#07152A",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 88,
    r: 8,
    fill: "#30D6A1"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 222,
    y: 78,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 222,
    dy: 0
  }, "YOUR OPERATIONAL PROBLEM"), /*#__PURE__*/React.createElement("tspan", {
    x: 222,
    dy: 22
  }, "The shared starting point"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325 140v48M325 188H155v30M325 188h170v30",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "5 7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 220,
    width: 250,
    height: 146,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.94,
    stroke: "#087CFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 254,
    r: 8,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 250,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 82,
    dy: 0
  }, "READY PLATFORM"), /*#__PURE__*/React.createElement("tspan", {
    x: 82,
    dy: 22
  }, "Unity Learning \xB7 TalentLenz"), /*#__PURE__*/React.createElement("tspan", {
    x: 82,
    dy: 22
  }, "FleetCore"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 220,
    width: 250,
    height: 146,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.94,
    stroke: "#FF2775"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 402,
    cy: 254,
    r: 8,
    fill: "#FF2775"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 422,
    y: 250,
    fill: "#07152A",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 12,
    fontWeight: 820,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 422,
    dy: 0
  }, "CUSTOM SYSTEM"), /*#__PURE__*/React.createElement("tspan", {
    x: 422,
    dy: 22
  }, "Designed and developed"), /*#__PURE__*/React.createElement("tspan", {
    x: 422,
    dy: 22
  }, "around your operation"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155 366v38h340v-38M325 404v24",
    fill: "none",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "5 7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 429,
    width: 270,
    height: 46,
    rx: 14,
    fill: "#10243E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 452,
    r: 7,
    fill: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 237,
    y: 457,
    fill: "#FFFFFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "A PRACTICAL NEXT STEP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAndusFinalCtaEngagementPathsDesktop);
export default __webpack_public_path__ + "static/media/about-andus-final-cta-engagement-paths-desktop.35cc9a666fe4d9e8d7d10118d1055f6f.svg";
export { ForwardRef as ReactComponent };